import androidType, { AndroidState, IAndroidAction } from "./android.type";

const initialState: AndroidState = {
  dataApp: undefined
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IAndroidAction) => {
  switch (action.type) {
    case androidType.APP_CONNECT.START:
      return {
        ...state,
        dataApp: action.payload
      };
    case androidType.APP_CONNECT.END:
      return {
        ...state,
        dataApp: undefined
      };
    default:
      return state;
  }
};
